import React from 'react';

import { AudienceCard } from '../modules/audience-card';

import { CategoryDashboard } from '../modules/audience-category-dashboard';
import { isInternalUser } from 'states/profile/business-rules';
import FlexSegmentsForm from 'forms/flex-segments-form';

const sortingOptions = [
    {
        label: 'Sort by: Newest',
        value: 'id',
        direction: 'desc',
    },
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
];

const FlexCustomLayout = ({
    audienceSegments,
    openFormModal,
    onSave,
    onSearch,
    activeAudience,
    organizationId,
}) => {
    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'custom_audiences' },
        linkBackLabel: 'Your Custom Audiences',
    };

    return (
        <CategoryDashboard
            audienceSegments={audienceSegments}
            onSearch={onSearch}
            segmentCount={audienceSegments ? audienceSegments.length : 0}
            createEditAction={openFormModal}
            activeAudience={activeAudience}
            organizationId={organizationId}
            sortingOptions={sortingOptions}
            description={
                'Built to reach audiences defined by project-based insights, this segment utilizes data beyond standard attributes to meet strategic objectives.'
            }
            title={'Custom Flex Geolocation'}
            linkToAudienceTab={linkToAudienceTab}
            bannerImagePath={
                '/images/audience-segments/banners/custom flex geolocation-banner.png'
            }
            modal={<FlexSegmentsForm onSave={onSave} type="custom" />}
            renderAudienceCard={segment => (
                <AudienceCard
                    onClick={
                        !isInternalUser() && segment.poi_source === 'legacy'
                            ? null
                            : () => openFormModal(segment.id)
                    }
                    segment={segment}
                    displayId={true}
                    active={segment.id === activeAudience}
                    organizationId={organizationId}
                />
            )}
            allowExternalCreate={true}
        />
    );
};

export default FlexCustomLayout;
